import { ascendingCompareFunction, descendingCompareFunction } from "store/global/global.utils";
export const prepareWorkspacesList = (workspaces) => {
    const locked = [];
    const unlocked = [];
    workspaces.forEach((workspace) => {
        if (workspace.isLocked) {
            locked.push(workspace);
        }
        else {
            unlocked.push(workspace);
        }
    });
    const compareFunction = (workspace1, workspace2) => new Date(workspace2.lastAccessed).getTime() - new Date(workspace1.lastAccessed).getTime();
    locked.sort(compareFunction);
    unlocked.sort(compareFunction);
    return { locked, unlocked };
};
export const getSortedResults = (workspaces, nameSortingDirection, lastAccessedSortingDirection) => {
    if (nameSortingDirection === null && lastAccessedSortingDirection === null) {
        return workspaces;
    }
    const lockedWorkspaces = workspaces.filter((item) => Boolean(item.isLocked));
    const availableWorkspaces = workspaces.filter((item) => !item.isLocked);
    const sortingParameter = nameSortingDirection !== null ? "name" : "lastAccessed";
    const sortingDirection = nameSortingDirection !== null ? nameSortingDirection : lastAccessedSortingDirection;
    if (sortingParameter === "lastAccessed") {
        const sortedWorkspaces = availableWorkspaces.sort((workspace1, workspace2) => {
            const a = new Date(workspace1.lastAccessed);
            const b = new Date(workspace2.lastAccessed);
            return sortingDirection === "asc" ? descendingCompareFunction(a, b) : ascendingCompareFunction(a, b);
        });
        return [...lockedWorkspaces, ...sortedWorkspaces];
    }
    else {
        const sorted = [...availableWorkspaces].sort((workspace1, workspace2) => {
            const a = workspace1.name.toLowerCase();
            const b = workspace2.name.toLowerCase();
            return sortingDirection === "asc" ? ascendingCompareFunction(a, b) : descendingCompareFunction(a, b);
        });
        return [...lockedWorkspaces, ...sorted];
    }
};
